import React from 'react'
import PropTypes from 'prop-types'
import EmptyState from '../ui/EmptyState'

// Bordered placeholder for the main evolution chart. Shared by Statistics and
// Evolution so both pages render an identical empty state.
const BOX_CLASSES = 'tw:h-80 tw:flex tw:items-center tw:justify-center '
  + 'tw:border tw:border-solid tw:border-ds-neutral-lowest tw:rounded-md!'

const ChartEmptyState = ({ message }) => (
  <div className={BOX_CLASSES}>
    <EmptyState message={message} />
  </div>
)

ChartEmptyState.propTypes = {
  message: PropTypes.string
}

ChartEmptyState.defaultProps = {
  message: ''
}

export default ChartEmptyState
